/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {clientAppSettings} from "../../Models/ClientAppSettings";

export interface RejectionDetailsPanelProps {
    message: string;
}

export interface RejectionDetailsPanelState {
}

export class RejectionDetailsPanel extends React.Component<RejectionDetailsPanelProps, RejectionDetailsPanelState> {
    constructor(props) {
        super(props);
    }

    render() {
        let guidelineUrl = `${clientAppSettings.documentationUrl}directory/review-guidelines/`;
        return (
            <div className="rejection-details-panel">
                <div className="dialog-close-button"></div>
                <div className="top-section">
                    <h2>Your bot submission was rejected</h2>
                </div>
                <div className="middle-section">
                    <div className="rejection-message">{this.props.message} &nbsp;
                    Questions? &nbsp;<a href="mailto:botreview@microsoft.com">botreview@microsoft.com</a></div>
                </div>
                <div className="bottom-section">
                    <div className="rejection-footer">
                        Please make sure to have a look at our <a href={guidelineUrl}>review guidelines</a> and the criteria 
                        we use to evaluate bots for the directory.
                    </div>
                    <div className="button-panel">
                        <button type="button" className="ok-button default-button">Close</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/RejectionDetailsPanel.tsx